<template>
  <div class="pager-container">
    <a
      class="large"
      :class="{ disabled: current === 1 }"
      @click="changePage(1)"
    >
      <Icon type="firstpage" />
    </a>
    <a
      class="small"
      :class="{ disabled: current === 1 }"
      @click="changePage(current - 1)"
    >
      <Icon type="left" />
    </a>
    <a
      v-for="item in currentNumbers"
      :key="item"
      :class="{ active: current === item }"
      @click="changePage(item)"
    >
      {{ item }}
    </a>
    <a
      class="small"
      :class="{ disabled: current === totalPage }"
      @click="changePage(current + 1)"
    >
      <Icon type="right" />
    </a>
    <a
      class="large"
      :class="{ disabled: current === totalPage }"
      @click="changePage(totalPage)"
    >
      <Icon type="lastpage" />
    </a>
    <span class="primary">{{ totalPage }}</span>
    <Icon class="large primary" type="fenye"></Icon>
  </div>
</template>

<script>
import Icon from "@/components/Icon";
export default {
  components: {
    Icon,
  },
  props: {
    current: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 10,
    },
    visibleNumber: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    totalPage() {
      return Math.ceil(this.total / this.limit);
    },
    firstNum() {
      const num = this.current - Math.ceil(this.limit / 2);
      if (num <= 0) {
        return 1;
      }
      return num;
    },
    lastNum() {
      let num = this.current + Math.floor(this.limit / 2) - 1;
      console.log(num);
      if (num < this.limit) {
        num = this.limit;
      }
      if (num > this.totalPage) {
        num = this.totalPage;
      }
      return num;
    },
    currentNumbers() {
      const arr = [];
      let first = 0;
      if (this.lastNum - this.firstNum < 10 && this.lastNum > 10) {
        first = this.lastNum - 9;
      } else {
        first = this.firstNum;
      }
      for (let i = first; i <= this.lastNum; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.totalPage) {
        return;
      }
      this.$emit("pageChange", page);
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/common.less";
@import "~@/styles/mixin.less";
.pager-container {
  .flex-center();
  .margin-row-20();
  color: @lightWords;
  a {
    color: @gray;
    margin: 0 6px;
    cursor: pointer;
    &.disabled {
      color: @lightWords;
      cursor: not-allowed;
      &:hover {
        color: @lightWords;
        font-weight: inherit;
      }
    }
    &.active {
      color: @primary;
      font-weight: bold;
      cursor: text;
    }
    &:hover {
      color: @primary;
      font-weight: bold;
    }
  }
}
</style>
